import { fontClasses, FontProps, FONT_COLOR } from '../font-props';
import './font-heading1.scss';
import '../font.scss';

const FontHeading1: React.FC<FontProps> = (props): JSX.Element => {
    props = {
        ...props,
        color: typeof props.color === "undefined" ? FONT_COLOR.PRIMARY2 : props.color
    };

    return (
        <h1 className={`font font-heading1 ${fontClasses(props)}`}>{props.children}</h1>
    )
};

export default FontHeading1;
